import axios from 'axios';

const codeTablePostgresApi = axios.create({
    baseURL: process.env.REACT_APP_CODE_TABLE_POSTGRES_API_URL
});

export default codeTablePostgresApi;